module.exports = [
  'BeardLight',
  'BeardMagestic',
  'BeardMedium',
  'Blank',
  'MoustacheFancy',
  'MoustacheMagnum'
]
